import { afterIdForDrop } from '@/src/renderer/lib/db/subtaskOrder'

/*
 * **Mehrere Unteraufgaben ziehen** (gewünscht 28.09.2026): Wer eine angefasste Zeile zieht, nimmt
 * die ganze Auswahl mit — wie in der Aufgabenliste.
 */

/** Was mitgeht: die Auswahl in Checklisten-Reihenfolge, wenn die gezogene Zeile dazugehört. */
export function dragGroup(ids: readonly string[], selected: ReadonlySet<string>, activeId: string): string[] {
  if (!selected.has(activeId) || selected.size < 2) return [activeId]
  return ids.filter(id => selected.has(id))
}

/**
 * Hinter welche Zeile der Block gehört, wenn die gezogene über `overId` losgelassen wird —
 * `null` heißt an den Anfang, `undefined` heißt: Es ändert sich nichts.
 *
 * Dieselbe Stelle wie für eine Zeile ({@link afterIdForDrop}); fällt sie auf eine Zeile des
 * Blocks, gilt deren nächster Vorgänger außerhalb.
 */
export function afterIdForGroupDrop(ids: readonly string[], group: readonly string[], activeId: string, overId: string): string | null | undefined {
  let after = afterIdForDrop([...ids], activeId, overId)
  if (after === undefined) return undefined
  const moving = new Set(group)
  while (after !== null && moving.has(after)) after = ids[ids.indexOf(after) - 1] ?? null

  const rest = ids.filter(id => !moving.has(id))
  const at = after === null ? 0 : rest.indexOf(after) + 1
  const next = [...rest.slice(0, at), ...ids.filter(id => moving.has(id)), ...rest.slice(at)]
  return next.every((id, i) => id === ids[i]) ? undefined : after
}
